var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKulpaIchip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Kulpa_I_chip",
    "data-name": "Kulpa I chip",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 20,
    viewBox: "0 0 58 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1.356,
    x2: 1.675,
    y2: -0.677,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#452cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23167e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3935",
    "data-name": "Rect\\xE1ngulo 3935",
    width: 58,
    height: 20,
    rx: 4,
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19998",
    "data-name": "Trazado 19998",
    d: "M2.122-1.863,2.066-3.2,6.433-7.7H7.686L4.307-4.138l-.615.678ZM1.156,0V-7.7H2.25V0ZM6.611,0,3.459-3.673l.732-.812L7.9,0Zm4.555.061A2.984,2.984,0,0,1,9.848-.213a1.967,1.967,0,0,1-.877-.839,2.9,2.9,0,0,1-.313-1.419V-5.826H9.714v3.234a1.787,1.787,0,0,0,.411,1.281,1.531,1.531,0,0,0,1.161.429,1.944,1.944,0,0,0,.953-.224,1.532,1.532,0,0,0,.629-.657,2.28,2.28,0,0,0,.224-1.056V-5.826h1.056V0h-1.01V-1.569l.171.414a2.058,2.058,0,0,1-.859.9A2.589,2.589,0,0,1,11.166.061ZM16.158,0V-8.162h1.056V0ZM22.31.061A2.707,2.707,0,0,1,20.983-.27a2.4,2.4,0,0,1-.96-.994,3.439,3.439,0,0,1-.358-1.648,3.513,3.513,0,0,1,.348-1.654,2.348,2.348,0,0,1,.95-.99,2.744,2.744,0,0,1,1.346-.331,3.049,3.049,0,0,1,1.52.373,2.718,2.718,0,0,1,1.046,1.041,3.092,3.092,0,0,1,.382,1.561,3.088,3.088,0,0,1-.382,1.559A2.718,2.718,0,0,1,23.829-.312,3.049,3.049,0,0,1,22.31.061ZM19.224,2.134v-7.96h1.01v1.57L20.17-2.9l.11,1.355v3.68Zm3-3a1.99,1.99,0,0,0,1-.252,1.837,1.837,0,0,0,.7-.717,2.175,2.175,0,0,0,.26-1.079A2.167,2.167,0,0,0,23.931-4a1.853,1.853,0,0,0-.7-.713,1.984,1.984,0,0,0-1-.253,1.984,1.984,0,0,0-1,.253,1.853,1.853,0,0,0-.7.713,2.167,2.167,0,0,0-.26,1.085,2.175,2.175,0,0,0,.26,1.079,1.837,1.837,0,0,0,.7.717A1.99,1.99,0,0,0,22.226-.863ZM30.281,0V-1.232l-.047-.234v-2.1A1.349,1.349,0,0,0,29.842-4.6a1.655,1.655,0,0,0-1.17-.367,3.105,3.105,0,0,0-1.017.169,2.644,2.644,0,0,0-.837.456l-.442-.786a3.2,3.2,0,0,1,1.088-.56,4.516,4.516,0,0,1,1.328-.194,2.674,2.674,0,0,1,1.847.585,2.28,2.28,0,0,1,.653,1.787V0ZM28.374.061a2.8,2.8,0,0,1-1.145-.217,1.726,1.726,0,0,1-.753-.607,1.554,1.554,0,0,1-.264-.892,1.66,1.66,0,0,1,.225-.856,1.571,1.571,0,0,1,.739-.617,3.379,3.379,0,0,1,1.376-.233H30.4v.766H28.6a1.58,1.58,0,0,0-1.06.262.844.844,0,0,0-.278.639.811.811,0,0,0,.343.688,1.564,1.564,0,0,0,.948.254,2,2,0,0,0,1.038-.263,1.512,1.512,0,0,0,.646-.771l.2.728a1.632,1.632,0,0,1-.739.821A2.666,2.666,0,0,1,28.374.061Zm9.239-7.013a.731.731,0,0,0,.77-.759.643.643,0,0,0-.671-.616.729.729,0,0,0-.759.737A.637.637,0,0,0,37.613-6.952ZM35.622,0h1.056l1.155-5.83H36.777Z",
    transform: "translate(9.937 14)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulpaIchip);
export default __webpack_public_path__ + "static/media/kulpaIchip.c34c314c058e754ae0fe7986743ef2b5.svg";
export { ForwardRef as ReactComponent };